import { add } from 'date-fns'
import { Types } from 'service-api'

export const generateBenefitDisplayName = (benefit: Types.BenefitAdminDto) => {
  return benefit.benefitOffers
    ?.map((benefitOffer) => benefitOffer.offer?.displayName)
    .filter((name) => !!name?.trim())
    .join(', ')
}

export const membershipDisplayName = (locationMembership: Types.LocationMembershipAdminDto | null | undefined) =>
  locationMembership?.displayName ||
  locationMembership?.membership?.displayName ||
  locationMembership?.name ||
  locationMembership?.membership?.name ||
  ''

export const findLocationUserProfileMembership = (
  locationUserProfileMemberships: Types.LocationUserProfileMembershipAdminDto[] | null | undefined,
  isAdmin?: boolean
) =>
  locationUserProfileMemberships?.find(
    (locationUserProfileMembership) =>
      locationUserProfileMembership?.subStatus === 'ACTIVE' &&
      (isAdmin ? locationUserProfileMembership?.status === 'ACTIVE' : true)
  ) ||
  locationUserProfileMemberships?.find(
    (locationUserProfileMembership) =>
      locationUserProfileMembership?.subStatus === 'PAUSED' &&
      (isAdmin ? locationUserProfileMembership?.status === 'ACTIVE' : true)
  ) ||
  locationUserProfileMemberships
    ?.filter(
      (locationUserProfileMembership) =>
        locationUserProfileMembership?.subStatus === 'CANCELED' &&
        (isAdmin ? locationUserProfileMembership?.status === 'ACTIVE' : true)
    )
    ?.sort((a, b) => {
      const dateA = new Date(a.createdAt || 0)
      const dateB = new Date(b.createdAt || 0)
      return dateB.getTime() - dateA.getTime()
    })?.[0]

export const nextActionDate = (
  startDate: Date,
  locationMembership: Types.LocationMembershipAdminDto | null | undefined
) => {
  switch (locationMembership?.membership?.billingCycle) {
    case 'WEEKLY':
      return add(startDate, { days: 7 })
    case 'FOUR_WEEKLY':
      return add(startDate, { days: 28 })
    case 'MONTHLY':
      return add(startDate, { days: 30 })
    case 'QUARTERLY':
      return add(startDate, { days: 90 })
    case 'ANNUALLY':
      return add(startDate, { days: 365 })
    default:
      return startDate
  }
}

export const findMembershipService = (locationServiceTypes?: Types.LocationServiceTypeAdminDto[]) => {
  return locationServiceTypes?.find(({ serviceType }) => serviceType?.name === 'memberships')
}

export const checkForActiveMembershipService = (locationServiceTypes?: Types.LocationServiceTypeAdminDto[]) => {
  return findMembershipService(locationServiceTypes)?.serviceType?.status === 'ACTIVE'
}
